import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { MapNote } from 'vms-base';
import s from './MapNoteFilter.module.scss';

const MapNoteTypeFilter = props => {
    const label = MapNote.MapNoteFilter.titleFor(props.value);
    return (
        <div className={s.labelWrapper}>
            <label htmlFor={props.value} className={s.option}>
                <input name={props.value} type="checkbox" onChange={() => props.onClick()} checked={props.checked} id={props.value} />
                <div className={classNames('icon-checkbox-tick', s.icon)} />
                <div className={s.label}>{label}</div>
            </label>
        </div>
    );
};
MapNoteTypeFilter.propTypes = {
    checked: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default MapNoteTypeFilter;
